import React from "react";
import discordLogo from "@/assets/auth/discord-logo.svg";
import ThirdPartyServiceButton, {
  ThirdPartyButtonProps,
} from "@/components/pages/auth/components/third-party-service-button";

const DiscordButton = ({
  title,
  callbackUrl,
  isDisabled,
}: ThirdPartyButtonProps) => {
  return (
    <ThirdPartyServiceButton
      title={title}
      provider={"discord"}
      logo={discordLogo}
      callbackUrl={callbackUrl}
      isDisabled={isDisabled}
    />
  );
};

export default DiscordButton;
